<template>
  <DialogYesNo
    v-bind:title="title"
    v-bind:visible="visible"
    @hidden="updateVmodel"
    @ok="submit"
  >
    <b-form @submit.prevent="submit">
      <b-form-input type="url" v-model="myUrl"></b-form-input>
    </b-form>
  </DialogYesNo>
</template>

<script>
import DialogYesNo from "@/components/DialogYesNo";
import { Web } from "@/assets/convenience.js";

export default {
  name: "DialogQuizStreamUrl",
  props: {
    visible: {
      default: false
    },
    title: {
      default: "Change URL"
    },
    url: {}
  },
  components: {
    DialogYesNo
  },
  data() {
    return {
      myUrl: this.url
    };
  },
  computed: {},
  model: {
    prop: "visible",
    event: "hidden"
  },
  created() {},
  methods: {
    updateVmodel() {
      this.$emit("hidden", false);
    },
    submit(ev) {
      if (this.myUrl.length > 0 && !Web.isValidWebUrl(this.myUrl)) {
        ev.preventDefault();
        return;
      }

      this.$emit("ok", ev, this.myUrl);
    }
  }
};
</script>
